<template>
  <div :class="`layout --${$route.name}`">
    <Navbar />
    <div class="layout__main-container">
      <Sidebar />
      <div class="layout__main-container__body" id="layout-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue';
import Navbar from '@/components/layout/Navbar.vue';

export default {
  name: 'layout',
  components: {
    Sidebar,
    Navbar,
  },
};
</script>

<style lang="scss" scoped>

.layout {
  position: relative;
  height: 100%;
  width: 100%;
  &__main-container {
    min-height: 100%;
    position: relative;
    @include breakpoint(desktop) {
      margin-left: var(--nxt-left-menu-size);
    }
    &__body {
      padding-top: 60px;
      background-size: 130% 125px;
      background-position: top center;
      background-image: url(../../assets/img/banner-filter.svg);
      background-repeat:no-repeat;
      @include breakpoint(tablet) {
        background-size: 100% 300px;
        padding-bottom: 10px;
      }
      @include breakpoint(desktop) {
        background-size: 100% 35vw;
      }
    }
  }
}
</style>
